import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Stepper from "./components/stepper";
import StepOne from "./steps/stepOne";
import StepTwo from "./steps/stepTwo";
import StepThree from "./steps/stepThree";
import StepFour from "./steps/stepFour";
import QuoteStep from "./steps/quoteStep";
import OutOfRange from "./steps/outOfRange";
import "./scss/main.scss";

export default function Calculator() {
	const initialState = {
		currentStep: 1,
		quoteDetails: {
			firstName: "",
			lastName: "",
			email: "",
			contactNumber: "",
			addressNameNum: "",
			partyType: "",
			partyDate: "",
			partyGuests: "",
			partyStandSeat: "",
			marqueeOptions: [],
		},
		eventInfo: {},
		marqueeInfo: {},
		marqueeOptions: {},
		contactDetails: {},
		quoteStep: {},
		paymentStep: {},
	};

	const [state, setState] = useState(initialState);

	const setQuoteDetails = useCallback((detail) => {
		if (Object.keys(detail).length > 0) {
			setState((prevState) => ({
				...prevState,
				quoteDetails: {
					...prevState.quoteDetails,
					...detail,
				},
			}));
		} else {
			setState((prevState) => ({
				...prevState,
				quoteDetails: {},
			}));
		}
	}, []);

	useEffect(() => {
		const href = window.location.href;
		const url = new URL(href);
		const params = new URLSearchParams(url.search);
		const utmSource = params.get("utm_source");

		if (utmSource) {
			setQuoteDetails({ utmSource });
		}
	}, [setQuoteDetails]);

	const setStepState = (step) => {
		setState((prevState) => ({
			...prevState,
			currentStep: step,
		}));
	};

	const handleStartAgain = () => {
		setStepState(1);
		setState(initialState);
		handleModalClose();
		getWordpressSettings();
	};

	const handleModalOpen = () => {
		const container = document.querySelector(".quote-calculator");
		const modal = document.querySelector(".start-again-modal");

		if (modal) {
			modal.classList.add("start-again-modal--open");

			setTimeout(() => {
				modal.classList.add("start-again-modal--visible");
				setTimeout(() => {
					container.classList.add("modal--open");
				}, 500);
			}, 100);
		}
	};

	const handleModalClose = () => {
		const container = document.querySelector(".quote-calculator");
		const modal = document.querySelector(".start-again-modal");

		if (modal) {
			container.classList.remove("modal--open");
			modal.classList.remove("start-again-modal--visible");

			setTimeout(() => {
				modal.classList.remove("start-again-modal--open");
			}, 100);
		}
	};

	const getWordpressSettings = async () => {
		try {
			const res = await axios.get(
				"https://www.abacusmarqueehire.co.uk/wp-json/acf/v3/options/options"
			);
			const {
				event_info,
				marquee_info,
				marquee_options,
				contact_details,
				quote_step,
				payment_step,
				email,
			} = res.data.acf;

			setState((prevState) => ({
				...prevState,
				eventInfo: event_info,
				marqueeInfo: marquee_info,
				marqueeOptions: marquee_options,
				contactDetails: contact_details,
				quoteStep: quote_step,
				paymentStep: payment_step,
				email: email,
			}));
		} catch (error) {
			console.error("Failed to fetch WordPress settings:", error);
		}
	};

	useEffect(() => {
		getWordpressSettings();
	}, []);

	const renderStep = () => {
		const {
			currentStep,
			eventInfo,
			marqueeInfo,
			marqueeOptions,
			contactDetails,
			quoteStep,
			paymentStep,
			email,
			quoteDetails,
		} = state;

		switch (currentStep) {
			case 0:
				return <OutOfRange eventInfo={eventInfo} />;

			case 1:
				return (
					<StepOne
						eventInfo={eventInfo}
						quoteDetails={quoteDetails}
						setQuoteDetails={setQuoteDetails}
						setStepState={setStepState}
					/>
				);

			case 2:
				return (
					<StepTwo
						marqueeInfo={marqueeInfo}
						quoteDetails={quoteDetails}
						setQuoteDetails={setQuoteDetails}
						setStepState={setStepState}
						handleStartAgain={handleModalOpen}
					/>
				);

			case 3:
				return (
					<StepThree
						marqueeOptions={marqueeOptions}
						quoteDetails={quoteDetails}
						setQuoteDetails={setQuoteDetails}
						setStepState={setStepState}
						handleStartAgain={handleModalOpen}
					/>
				);

			case 4:
				return (
					<StepFour
						contactDetails={contactDetails}
						quoteDetails={quoteDetails}
						setQuoteDetails={setQuoteDetails}
						setStepState={setStepState}
						handleStartAgain={handleModalOpen}
						zapierLink={quoteStep.zapier_link}
					/>
				);

			case 5:
				return (
					<QuoteStep
						quoteStep={quoteStep}
						paymentStep={paymentStep}
						email={email}
						quoteDetails={quoteDetails}
						setStepState={setStepState}
						setQuoteDetails={setQuoteDetails}
						handleStartAgain={handleModalOpen}
						zapierLink={quoteStep.zapier_link}
						thankYouPage={quoteStep.thank_you_page}
					/>
				);

			default:
				return (
					<StepOne
						eventInfo={eventInfo}
						quoteDetails={quoteDetails}
						setQuoteDetails={setQuoteDetails}
						setStepState={setStepState}
						handleStartAgain={handleModalOpen}
					/>
				);
		}
	};

	return (
		<div className="quote-calculator">
			{state.currentStep < 2 ? (
				<img
					src="https://www.abacusmarqueehire.co.uk/wp-content/uploads/Abacus-Logo.png"
					width={120}
					alt="Abacus Marquee Hire"
				/>
			) : null}

			{![0, 5, 6].includes(state.currentStep) &&
			state.eventInfo.heading ? (
				<Stepper currentStep={state.currentStep} />
			) : null}

			{state.eventInfo.heading ? (
				renderStep()
			) : (
				<div className="loader">
					<div className="loader-inner"></div>
					<div className="loader-triangle"></div>
				</div>
			)}

			<div className="start-again-modal">
				<div>
					<p>Are you sure you want to start again?</p>
					<p>(All selections will be lost)</p>
					<button
						onClick={handleStartAgain}
						className="start-again-modal__remove-btn"
					>
						Yes
					</button>
					<button
						onClick={handleModalClose}
						className="start-again-modal__close-btn"
					>
						No
					</button>
				</div>
			</div>
		</div>
	);
}
